import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import{warninTime, logoutTime} from "./utils"

const AutoLogout = ({ children }) => {
  const timeoutRef = useRef(null);
  const warningTimeoutRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    sessionStorage.removeItem("ASIToken");
    sessionStorage.removeItem("ASIUser");
    navigate("/login");
  };

  const startTimers = () => {
    clearTimeout(timeoutRef.current);
    clearTimeout(warningTimeoutRef.current);

    warningTimeoutRef.current = setTimeout(() => {
      setShowWarning(true);

      toast.warn("You have been logged out due to inactivity.", {
        position: "top-right",
        autoClose: false, // stays open until the user closes it
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

    }, warninTime); // Show warning at 4.5 min

    timeoutRef.current = setTimeout(() => {
      logout();
    }, logoutTime); // Auto logout at 5 min
  };

  const resetTimers = () => {
    setShowWarning(false);
    startTimers();
  };

  useEffect(() => {

    let token = sessionStorage.getItem("ASIToken");

    console.log("Token: ", token);

    if (!token) {
      logout()
    }

    startTimers();
    const events = ["mousemove", "mousedown", "keypress", "touchstart", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimers));

    return () => {
      clearTimeout(timeoutRef.current);
      clearTimeout(warningTimeoutRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimers));
    };
  }, []);

  return (
    <>
      {children}
    </>
  );
};

export default AutoLogout;
